export default "__VITE_ASSET__YjhhKi1C__"